import {
    FETCHED_FAQS,
    FETCHED_FAQ,
    FETCH_FAQS_TYPES,
    UPDATED_FAQ,
    DELETED_FAQ,
    FETCHED_FAQS_TRANSLATIONS,
    FETCHED_FAQ_TRANSLATION,
    CREATED_FAQ_TRANSLATION,
    UPDATED_FAQ_TRANSLATION,
    DELETED_FAQ_TRANSLATION,
    FAQ_SEARCH_BY,
    FETCHED_FAQS_BY_SEARCH_TERMS,
    CLEAR_FAQS_SEARCH_FILTER
} from './types';

import update from 'immutability-helper';

const INITIAL_STATE = {
    all: [],
    faq: {},
    faqsTypes: [],
    faqsTranslations: [],
    faqTranslation: {},
    faqSearchCriteria: '',
    allFaqsBySearchTerms: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case FETCHED_FAQS:

            return update(state, {
                all: {$set: action.payload.data}
            });

        case FETCHED_FAQ:

            return update(state, {
                faq: {$set: action.faq}
            });

        case FETCH_FAQS_TYPES:

            return update(state, {
                faqsTypes: {$set: action.faqsTypes}
            });

        case UPDATED_FAQ:
            return update(state, {
                faq: {$set: action.faq}
            });

        case DELETED_FAQ:

            let allFaqs = state.all.filter(item => item.id !== action.faqId);

            return update(state, {
                all: {$set: allFaqs}
            });

        case FETCHED_FAQS_TRANSLATIONS:

            return update(state, {
                faqsTranslations: {$set: action.faqsTranslations}
            });

        case FETCHED_FAQ_TRANSLATION:

            return update(state, {
                faqTranslation: {$set: action.faqTranslation}
            });

        case CREATED_FAQ_TRANSLATION:

            return update(state, {
                faqTranslation: {$set: action.faqTranslation}
            });

        case UPDATED_FAQ_TRANSLATION:

            return update(state, {
                faqTranslation: {$set: action.faqTranslation}
            });

        case DELETED_FAQ_TRANSLATION:

            let allFaqsTranslations = state.faqsTranslations.filter(item => item.id !== action.translationId);

            return update(state, {
                faqsTranslations: {$set: allFaqsTranslations}
            });

        case FETCHED_FAQS_BY_SEARCH_TERMS:

            return update(state, {
                allFaqsBySearchTerms: {$set: action.payload},
            });

        case FAQ_SEARCH_BY:

            return update(state, {
                faqSearchCriteria: {$set: action.payload.searchBy},
            });

        case CLEAR_FAQS_SEARCH_FILTER:

            return update(state, {
                allFaqsBySearchTerms: {$set: []},
                faqSearchCriteria: {$set: ''}
            });

        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/containers/faqs/reducer.js